"use strict";
import AOS from "aos";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";
import mobileMenu from "./scripts/menu/mobileMenu";
import headerScrolling from "./scripts/headerScrolling";
import heroParallax from "./scripts/heroParallax";
import leveling from "./scripts/leveling";
import clienteSlider from "./scripts/clienteSlider";

AOS.init({
    once: true,
});

mobileMenu();
heroParallax();
headerScrolling();
leveling();
clienteSlider();
